import React from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import SearchInput from "./components/SearchInput";
import FormInput from "./components/FormInput";
import TagInput from "./components/TagInput";
import Dropdown from "./components/Dropdown";
import Textarea from "./components/Textarea";
import PhoneNumberInput from "./components/PhoneNumberInput";
import PasswordInput from "./components/PasswordInput";
import DateTimePicker from "./components/DateTime/DateTimePicker";

const AccreditationInput = ({
  placeholder,
  label,
  className,
  classNameCalendar,
  value,
  setInputValue,
  tags,
  onTagsChange,
  setSelectedOption,
  selectedOption,
  type,
  options,
  valueType,
  suggestions,
  error,
  setPhone,
  setCountry,
  valuePhone,
  valueCode,
  onKeyDown,
  variant,
  searchable,
  disabled,
  flags,
  autoComplete,
  name,
  required,
  email,
  birthDate,
  registration_deadline,
}) => {
  if (value === null) {
    value = "";
  }
  return (
    <div
      className={`${
        className ? className : ""
      } flex-direction-row items-center accreditation-input ${
        variant === "send-all" ? "send-all" : ""
      }`}
    >
      {type === "search" ? (
        <SearchInput
          handleValueChange={(value) => setInputValue(value)}
          placeholder={placeholder}
          value={value}
          onKeyDown={onKeyDown}
        />
      ) : type === "tag" ? (
        <TagInput
          tags={tags}
          onTagsChange={(newTags) => onTagsChange(newTags)}
          placeholder={placeholder}
          label={label}
          valueType={valueType}
          suggestions={suggestions}
          onKeyDown={onKeyDown}
          variant={variant}
        />
      ) : type === "dropdown" ? (
        <Dropdown
          label={label}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          options={options}
          onKeyDown={onKeyDown}
          searchable={searchable}
          variant={variant}
          disabled={disabled}
          flags={flags}
          error={error}
          required={required}
        />
      ) : type === "text-area" ? (
        <Textarea
          placeholder={placeholder}
          label={label}
          type={type}
          handleValueChange={(value) => setInputValue(value)}
          value={value}
          onKeyDown={onKeyDown}
          email={email}
          required={required}
          error={error}
        />
      ) : type === "phone" ? (
        <PhoneNumberInput
          value={value}
          setPhone={(value) => setPhone(value)}
          setCountry={(value) => setCountry(value)}
          valuePhone={valuePhone}
          valueCode={valueCode}
          onKeyDown={onKeyDown}
        />
      ) : type === "password" ? (
        <PasswordInput
          placeholder={placeholder}
          label={label}
          handleValueChange={(value) => setInputValue(value)}
          value={value}
          onKeyDown={onKeyDown}
          autoComplete={autoComplete}
          name={name}
          required={required}
          error={error}
        />
      ) : type === "datetime-local" ? (
        <DateTimePicker
          value={value}
          onChange={(value) => setInputValue(value)}
          placeholder={placeholder}
          label={label}
          error={error}
          required={required}
          birthDate={birthDate}
          classNameCalendar={classNameCalendar}
          registration_deadline={registration_deadline}
        />
      ) : (
        <FormInput
          placeholder={placeholder}
          label={label}
          handleValueChange={(value) => setInputValue(value)}
          value={value}
          error={error}
          type={type}
          onKeyDown={onKeyDown}
          disabled={disabled}
          autoComplete={autoComplete}
          name={name}
          required={required}
        />
      )}
    </div>
  );
};
export default AccreditationInput;
